import { create } from 'zustand';

type SwitchStatus = 'idle' | 'holding' | 'pending' | 'locked' | 'error';

interface UIState {
    currentBoard: 'HOME' | 'ORDER';
    switchStatus: SwitchStatus;
    setCurrentBoard: (board: 'HOME' | 'ORDER') => void;
    setSwitchStatus: (status: SwitchStatus) => void;
    requestModeChange: (mode: 'HOME' | 'ORDER') => Promise<boolean>;
}

export const useUIStore = create<UIState>((set, get) => ({
    currentBoard: 'HOME',
    switchStatus: 'idle',

    setCurrentBoard: (board) => set({ currentBoard: board }),

    setSwitchStatus: (status) => set({ switchStatus: status }),

    // Backend validation hook for mode changes
    // This can be extended to call actual backend APIs
    requestModeChange: async (mode) => {
        const { switchStatus } = get();

        // Don't allow changes if locked
        if (switchStatus === 'locked') {
            return false;
        }

        // Set pending status
        set({ switchStatus: 'pending' });

        try {
            // Simulate backend validation (replace with actual API call)
            await new Promise(resolve => setTimeout(resolve, 300));

            // For now, always approve
            // In production, this would check:
            // - Payment status
            // - KYC verification
            // - Rate limits
            // - Admin locks
            const approved = true;

            if (approved) {
                set({
                    currentBoard: mode,
                    switchStatus: 'idle'
                });
                return true;
            } else {
                set({ switchStatus: 'error' });
                // Reset to idle after showing error
                setTimeout(() => {
                    set({ switchStatus: 'idle' });
                }, 1500);
                return false;
            }
        } catch (error) {
            console.error('Mode change failed:', error);
            set({ switchStatus: 'error' });
            setTimeout(() => {
                set({ switchStatus: 'idle' });
            }, 1500);
            return false;
        }
    },
}));
